(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('harmain-testimonials')) {
  customElements.define('harmain-testimonials', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.updateSummary = () => {
        const link = document.querySelector('.product-feedback-link');
        const rating = Number(this.dataset.rating);
        const count = Number(this.dataset.ratingCount);
        if (!link || !rating || !count) return;
        if (!this.originalLink) this.originalLink = { html: link.innerHTML, href: link.getAttribute('href') };
        const stars = document.createElement('span');
        stars.className = 'hm-rating-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.style.setProperty('--star-fill', `${rating * 20}%`);
        stars.append(document.createTextNode('★★★★★'));
        const fill = document.createElement('span');
        fill.textContent = '★★★★★';
        stars.append(fill);
        const label = document.createElement('span');
        label.textContent = `${rating}/5 · ${count.toLocaleString('en-GB')} footwear reviews`;
        link.replaceChildren(stars, label);
        link.setAttribute('href', `#${this.id}`);
      };
      this.updateSummary();
      document.addEventListener('harmain:variant-change', this.updateSummary);
      const countLabel = this.querySelector('.hm-review-count');
      if (countLabel) countLabel.textContent = Number(this.dataset.ratingCount).toLocaleString('en-GB');
      const button = this.querySelector('.hm-review-toggle');
      if (this.dataset.autoplay !== 'true' || !button) return;
      const groups = [...this.querySelectorAll('.hm-review-group')];
      if (!groups.length || groups.some(group => group.children.length < 2)) return;
      groups.forEach(group => {
        // Repeat a short row so wide screens never reveal an empty track.
        const originals = [...group.children];
        while (group.children.length < 4) {
          originals.forEach(card => {
            const copy = card.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.inert = true;
            copy.removeAttribute('data-shopify-editor-block');
            group.append(copy);
          });
        }
        const duplicate = group.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        duplicate.inert = true;
        duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        group.parentElement.append(duplicate);
      });
      this.dataset.moving = 'true';
      button.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        if (!paused) {
          delete this.dataset.manual;
          this.querySelectorAll('.hm-review-row').forEach(row => { row.scrollLeft = 0; });
        }
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('span').textContent = paused ? 'Resume motion' : 'Pause motion';
      });
      this.querySelectorAll('.hm-review-row').forEach(row => {
        row.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch') return;
          this.dataset.manual = 'true';
          this.dataset.paused = 'true';
          button.setAttribute('aria-pressed', 'true');
          button.querySelector('span').textContent = 'Resume motion';
        });
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.dataset.inView = String(entries[0].isIntersecting);
        });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('harmain:variant-change', this.updateSummary);
      const link = document.querySelector('.product-feedback-link');
      if (this.originalLink && link?.getAttribute('href') === `#${this.id}`) {
        link.innerHTML = this.originalLink.html;
        link.setAttribute('href', this.originalLink.href);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
